"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockCustomImagesResponse = void 0;
var mockCustomImagesResponse = {
  images: [{
    hash: 'd4585847af5838e1f2997d14d03775c8',
    isRemoved: false,
    label: 'Toppings.ToppingImage_Web.TOP-CBAC.1.jpg',
    url: 'https://lcemedia.littlecaesars.com/custompizza/Toppings.ToppingImage_Web.TOP-CBAC.1.jpg',
    uuid: '2f2fa82a-9a3d-4c56-adaf-d5d61e1a606d'
  }, {
    hash: 'ddda203d4dafa472b4bda84bd16abbe7',
    isRemoved: false,
    label: 'Toppings.ToppingImage_Web.TOP-ONI.1.jpg',
    url: 'https://lcemedia.littlecaesars.com/custompizza/Toppings.ToppingImage_Web.TOP-ONI.1.jpg',
    uuid: '9f5377cb-cffd-4600-9442-992fbf509aa9'
  }],
  succeeded: true
};
exports.mockCustomImagesResponse = mockCustomImagesResponse;